<template>
  <div>
    <p>Here are your current and previous promotions:</p>
    <br/>
    <div class="pos-relative">
      <p>Articles submitted:</p>
      <Card dis-hover style="min-height:100px;margin-left:20px;">
        <p v-if="activePromotions.articles_submitted">
          <template v-for="line in activePromotions.articles_submitted.split('\n')" >
            <p v-html="line" :key="line"><br/></p>
          </template>
        </p>
        <p v-else style="font-style:italic">Not yet</p>
      </Card>
      <br/>
      <p>Featured on Homepage and Explore page:</p>
      <Card dis-hover style="min-height:100px;margin-left:20px;">
        <p v-if="activePromotions.featured_on">
          <template v-for="line in activePromotions.featured_on.split('\n')" >
            <p v-html="line" :key="line"><br/></p>
          </template>
        </p>
        <p v-else style="font-style:italic">Not yet</p>
      </Card>
      <br/>
      <p>Events published:</p>
      <Card dis-hover style="min-height:100px;margin-left:20px;">
        <p v-if="activePromotions.events_published">
          <template v-for="line in activePromotions.events_published.split('\n')" >
            <p v-html="line" :key="line"><br/></p>
          </template>
        </p>
        <p v-else style="font-style:italic">Not yet</p>
      </Card>
      <Spin size="small" fix v-if="isLoading"></Spin>
    </div>
    <p class="padding-t-20"><b>Increase your visibility!</b></p>
    <ul style="margin-left: 35px;">
      <li>To submit your own article about your solution, please <a href="https://kromnix.com/solutions/tech-providers/submit-your-article" target="_blank">click here</a>.</li>
      <li>To feature your company on our homepage and to be visible at the top of the Explore page, please <a href="https://kromnix.com/solutions/tech-providers/feature-your-company" target="_blank">click here</a>.</li>
      <li>To promote your own events, please <a href="https://kromnix.com/solutions/tech-providers/promote-your-events" target="_blank">click here</a>.</li>
    </ul>
  </div>
</template>

<script>
import { fetchActivePromotions } from '@/services/dashboard'

export default {
  data () {
    return {
      isLoading: false,
      activePromotions: {
        articles_submitted: '',
        featured_on: '',
        events_published: ''
      }
    }
  },

  mounted () {
    this.getActivePromotions()
  },

  methods: {
    handleRedirect () {
      this.$router.push({
        name: 'companies'
      })
    },

    getActivePromotions () {
      this.isLoading = true
      fetchActivePromotions().then(res => {
        if (res.data.results && res.data.results.length) {
          this.activePromotions = res.data.results[0]
        }
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch active promotions: ', err)
        this.isLoading = false
      })
    }
  }
}
</script>
